import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 11,
    type: CHECKLIST_ITEM_TYPE.SEND_CONSENT_FORM,
    manifestKey: 'SEND_CONSENT_FORM',

    try_it: {
        button_label: 'Send Consent Form',
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'SendConsentFormCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { consent_form_id: 'demo-consent-001' },
        },
    },
    pre_flight_diff: [
        'Step 1: Consent form email dispatched (separate pre-complete action)',
        'Step 2: POST /checklist/{iid}/complete/ — checklist item: PENDING → YES',
        'task_consent_form_sent Action logged to lead timeline',
        'Email added to lead\'s outgoing email tab',
        '⚠ Drift risk: consent email sent but complete POST fails → duplicate consent email on retry',
    ],
    has_step2_throttle: true,
    validation_laboratory: null,
};
